import { Progress, TabBar } from "d-react-components";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import EquipmentStockRequestAPI from "../../../../api/queries/equipment-stock-request";
import { EquipmentStockRequestDetailContext } from "../../../../context/equipment-stock-request";
import Messages from "../../../../languages/Messages";
import EquipmentStockRequestActivity from "./EquipmentStockRequestActivity";
import EquipmentStockRequestHeader from "./EquipmentStockRequestHeader";
import EquipmentStockRequestSummary from "./EquipmentStockRequestSummary";
import EquipmentStockRequestGeneral from "./EquipmentStockRequestGeneral";
import EquipmentStockRequestItems from "./EquipmentStockRequestItems";

const TABS = [
    {
        id: "general",
        label: Messages.generalInformation,
        component: <EquipmentStockRequestGeneral />,
    },
    {
        id: "service",
        label: Messages.items,
        component: <EquipmentStockRequestItems />,
    },
    {
        id: "activity",
        label: Messages.activity,
        component: <EquipmentStockRequestActivity />,
    },
];

const EquipmentStockRequestDetail = () => {
    const { stockRequestId } = useParams<any>();
    const [stockRequest, setStockRequest] = useState<any>();
    const [tab, setTab] = useState(TABS[0]);

    useEffect(() => {
        loadRequestDetail();
    }, []);

    const loadRequestDetail = () => {
        Progress.show(
            {
                method: EquipmentStockRequestAPI.detail,
                params: [stockRequestId],
            },
            setStockRequest as any
        );
    };

    if (!stockRequest) {
        return <div />;
    }

    return (
        <EquipmentStockRequestDetailContext.Provider
            value={{ stockRequest, setStockRequest }}
        >
            <div className="flex-column-container bg-white">
                <EquipmentStockRequestHeader />
                <div className="px-4 py-3">
                    <div className="grid grid-cols-4 gap-4">
                        <div className="col-span-1">
                            <EquipmentStockRequestSummary />
                        </div>
                        <div className="col-span-3">
                            <TabBar
                                dataSource={TABS}
                                onChange={setTab as any}
                                value={tab}
                            />
                            <div className="bg-white mt-3">{tab.component}</div>
                        </div>
                    </div>
                </div>
            </div>
        </EquipmentStockRequestDetailContext.Provider>
    );
};

export default EquipmentStockRequestDetail;
